import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Apothecary from "@/pages/Apothecary";
import PrescriptionRequest from "@/pages/PrescriptionRequest";
import AdminAnalytics from "@/pages/AdminAnalytics";
import AdminOverview from "@/pages/AdminOverview";
import AdminMembers from "@/pages/AdminMembers";
import AdminPrescriptions from "@/pages/AdminPrescriptions";
import Dashboard from "@/pages/Dashboard";
import Pricing from "@/pages/Pricing";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Library from "@/pages/Library";
import ContentDetail from "@/pages/ContentDetail";
import Practitioners from "@/pages/Practitioners";
import Contact from "@/pages/Contact";
import BecomeSteward from "@/pages/BecomeSteward";
import BecomeHealer from "@/pages/BecomeHealer";
import Concierge from "@/pages/Concierge";
import Biomarkers from "@/pages/Biomarkers";
import BioAge from "@/pages/BioAge";
import Microbiome from "@/pages/Microbiome";
import Intake from "@/pages/Intake";
import Digest from "@/pages/Digest";
import AdminCurate from "@/pages/AdminCurate";
import AdminCaring from "@/pages/AdminCaring";
import AdminApothecary from "@/pages/AdminApothecary";
import AdminProtocols from "@/pages/AdminProtocols";
import AdminSocial from "@/pages/AdminSocial";
import CaringForCountry from "@/pages/CaringForCountry";
import WomensVitality from "@/pages/WomensVitality";
import AdminWomens from "@/pages/AdminWomens";
import AdminAudit from "@/pages/AdminAudit";
import AdminResearch from "@/pages/AdminResearch";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/apothecary" element={<Apothecary />} />
            <Route path="/prescription-request" element={<PrescriptionRequest />} />
            <Route path="/admin" element={<AdminOverview />} />
            <Route path="/admin/members" element={<AdminMembers />} />
            <Route path="/admin/prescriptions" element={<AdminPrescriptions />} />
            <Route path="/admin/analytics" element={<AdminAnalytics />} />
            <Route path="/admin/audit" element={<AdminAudit />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/library" element={<Library />} />
            <Route path="/library/:id" element={<ContentDetail />} />
            <Route path="/caring-for-country" element={<CaringForCountry />} />
            <Route path="/womens-vitality" element={<WomensVitality />} />
            <Route path="/practitioners" element={<Practitioners />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/become-a-steward" element={<BecomeSteward />} />
            <Route path="/become-a-healer" element={<BecomeHealer />} />
            <Route path="/checkout/success" element={<ProtectedRoute><CheckoutSuccess /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/intake" element={<ProtectedRoute><Intake /></ProtectedRoute>} />
            <Route path="/concierge" element={<ProtectedRoute requirePlan><Concierge /></ProtectedRoute>} />
            <Route path="/biomarkers" element={<ProtectedRoute><Biomarkers /></ProtectedRoute>} />
            <Route path="/bioage" element={<ProtectedRoute><BioAge /></ProtectedRoute>} />
            <Route path="/microbiome" element={<ProtectedRoute><Microbiome /></ProtectedRoute>} />
            <Route path="/digest" element={<ProtectedRoute><Digest /></ProtectedRoute>} />
            <Route path="/admin/curate" element={<ProtectedRoute><AdminCurate /></ProtectedRoute>} />
            <Route path="/admin/caring" element={<ProtectedRoute><AdminCaring /></ProtectedRoute>} />
            <Route path="/admin/womens-vitality" element={<ProtectedRoute><AdminWomens /></ProtectedRoute>} />
            <Route path="/admin/apothecary" element={<ProtectedRoute><AdminApothecary /></ProtectedRoute>} />
            <Route path="/admin/protocols" element={<ProtectedRoute><AdminProtocols /></ProtectedRoute>} />
            <Route path="/admin/social" element={<ProtectedRoute><AdminSocial /></ProtectedRoute>} />
            <Route path="/admin/research" element={<ProtectedRoute><AdminResearch /></ProtectedRoute>} />
          </Routes>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
